import { connect } from 'react-redux'
import { PrintPreview } from './PrintPreview.jsx'
import {
    determinePrintOrientation,
} from 'redux/print/actions'
import {
    getPrintOrientationAngle,
    getPreviewSheet,
} from 'redux/print/selectors'

export const mapStateToProps = (state, props) => ({
    previewSheet: getPreviewSheet(state, props.frame),
    printOrientationAngle: getPrintOrientationAngle(state),
})

export const mapDispatchToProps = (dispatch) => ({
    determinePrintOrientation: () => dispatch(determinePrintOrientation()),
})

export const PrintPreviewContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PrintPreview)
